import { Map } from 'immutable';
import * as relocationInventoryDetails from '../../actions/relocation/relocationInventoryDetails';

const initialState = Map({
  siteDetails: [],
  lessSiteDetails:[],
  checkBoxList:[],
  validation:[],
  isNextStep:false,
  removalDetails:{},
  form:[],
  relocationDetails:[],
  planServiceId :[]
});

const actionsMap = {
  [relocationInventoryDetails.UPDATE_SITEDETAILS]: (state, action) => {
    return state.set('siteDetails', action.data);
  },
  [relocationInventoryDetails.UPDATE_LESS_SITEDETAILS]: (state, action) => {
    return state.set('lessSiteDetails', action.data);
  },
  [relocationInventoryDetails.UPDATECHECKBOXVALUE]: (state, action) => {
    return state.set('checkBoxList', action.data);
  },
  [relocationInventoryDetails.UPDATEVALIDATION]: (state, action) => {
    return state.set('validation', action.data);
  },
  [relocationInventoryDetails.UPDATENEXTSTEPSTATUE]: (state, action) => {
    return state.set('isNextStep', action.data);
  },
  [relocationInventoryDetails.SAVEREMOVALDETAILS]: (state, action) => {
    return state.set('removalDetails', action.data);
  },
  [relocationInventoryDetails.SAVEFORMVALUES]: (state, action) => {
    return state.set('form', action.data);
  },
  [relocationInventoryDetails.SAVERETRIEVERELOCATIONPLANDETAILS]: (state, action) => {
    return state.set('relocationDetails', action.data);
  },
  [relocationInventoryDetails.SAVERELOCATIONSERVICEID]: (state, action) => {
    return state.set('planServiceId', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}